import initHeader from "./components/header";
import initFooter from "./components/footer";
import initHomePage from "./pages/homepage";
import initCategory from "./pages/category";
import initProductDetailPage from "./pages/product-detail";
import initProduct from "./components/product";
import initCart from "./pages/cart";
import initArticle from "./pages/article";
import initRegistration from "./pages/registration";
import initMap from "./components/map";

console.log("Custom JS loadesw");

const retinaImages = () => {
    const productsDataSrcImages = [
        ...document.querySelectorAll(".products img[data-src]"),
    ];

    const replaceAttributeValue = (img, attributeName) => {
        const attributeValue = img.getAttribute(attributeName);
        img.setAttribute(
            attributeName,
            attributeValue.replace("/detail/", "/big/")
        );
    };

    productsDataSrcImages.forEach((img) => {
        replaceAttributeValue(img, "src");
        replaceAttributeValue(img, "data-src");
    });
};

const debugImages = () => {
    const shopImages = document.querySelectorAll("img");
    if (shopImages) {
        shopImages.forEach((image) => {
            const imageSrc = image.getAttribute("src");

            if (imageSrc && !imageSrc.includes("data:")) {
                let srcParametersChar = "?";
                if (imageSrc.includes("?")) {
                    srcParametersChar = "&";
                }
                image.setAttribute(
                    "src",
                    `${imageSrc}${srcParametersChar}v=${Date.now()}`
                );
            }
        });
    }
};

// Init app
window.addEventListener("DOMContentLoaded", () => {
    // retinaImages();
    // initHeader();
    initFooter();
    initHomePage();
    // initCategory();
    initCart();
    // initArticle();
    // initRegistration();
    initProductDetailPage();
    // initProduct();
    // debugImages();
    // initMap();
});